import { IProductReference } from '@epicuro-next/data/product';
import { isNonNullish } from '@epicuro-next/utilities';

export function mapProductsByReferenceOrder(
  products: IProductReference[],
  productReferences: IProductReference[],
) {
  if (products.length === 0) return [];

  const productsMapper = products.map<[string, IProductReference]>(
    (product) => [product.productId, product],
  );

  const productsMap = new Map(productsMapper);

  return productReferences
    .filter(({ productId }) => productsMap.has(productId))
    .map(({ productId }) => productsMap.get(productId))
    .filter(isNonNullish);
}
